module.exports = __webpack_public_path__ + "img/electronic-farm-empty.c28c19c9.svg";